export enum ServiceRequestStateEnum {
  ACCEPTED = 'Accepted',
  REQUESTED = 'Request',
  NOT_PUBLISHED = 'NotPublished',
}
